import { setValueValue } from '@databases/collab/y-database';
import { MutableEntry } from '@databases/model/entry';
import { FieldType } from '@databases/model/field';
import { AllValueJSON, MutableValue } from '@databases/model/value';

export function getOrSetValue<T extends FieldType>(
  entry: MutableEntry,
  fieldId: string,
  type: T,
  defaultValue?: AllValueJSON
): MutableValue<T> {
  const value = entry.getValue(fieldId);

  if (value && value.type === type) {
    return value as MutableValue<T>;
  } else {
    const newValue = entry.setValue(fieldId, type);

    if (defaultValue) {
      setValueValue(newValue, defaultValue);
    }

    return newValue;
  }
}
